import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initTestimonialsSwiper() {
    const swiper  = new Swiper('.init-testimonials-swiper', {
        modules: [Navigation],
        // Navigation arrows
        navigation: {
            nextEl: '.testimonials__nav .btn-next',
            prevEl: '.testimonials__nav .btn-prev',
        },

        spaceBetween: 60,

        breakpoints: {
            768: {
                slidesPerView: 2,
            },

            1025: {
                slidesPerView: 3,
            },
        },

        slidesPerView: 'auto',
    });
}

function pauseVideos() {
    const playVideo = document.querySelectorAll('.js-play-video');

    if(playVideo.length) {
        [...playVideo].forEach((item) => {
            let video = item.previousElementSibling;

            if(video) {
                if(!video.paused) {
                    video.pause();
                    video.nextElementSibling.classList.remove('hide');
                }
            }
        });
    }
}

function initVideoSwiper() {
    const swiper  = new Swiper('.init-video-swiper', {
        modules: [Navigation],
        // Navigation arrows
        navigation: {
            nextEl: '.video__nav .btn-next',
            prevEl: '.video__nav .btn-prev',
        },

        slidesPerView: 1,
    });

    swiper.on('slideChange', function () {
        pauseVideos();
    });
}

export { initTestimonialsSwiper, initVideoSwiper }
